import type { ObrasDateFilterProps, ObrasDateFilterViewModel } from "./types-obras-date-filter";

export function useObrasDateFilter({
  range,
  onChange,
}: ObrasDateFilterProps): ObrasDateFilterViewModel {
  const isFilled = Boolean(range?.[0] || range?.[1]);

  return { range, onChange, isFilled };
}
